/** Frontmatter for the "week2-waiver-wire-priority-board" article; the Body lives in week2-waiver-wire-priority-board.jsx. */
const meta = {
  slug: 'week2-waiver-wire-priority-board',
  title: 'Week 2 Waiver Wire: The Priority Board',
  category: 'Waivers',
  author: 'Andy Darkness',
  excerpt: 'Ten pickups ranked by FAAB bid, led by Jalen Coker and Isaiah Likely, plus position-by-position adds and stashes worth spending Week 2 waiver budget on.',
  readMinutes: 9,
  date: '2026-09-15',
};

export default meta;
